import React, { useCallback, useState } from "react";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";
import { addNewUser } from "../../api/user";
import ErrorToast from "../../layouts/nav/ErrorToast";

const initialState = {
  username: "",
  password: "",
  repassword: "",
  email: "",
  role_id: "",
  quota: "",
  user_type: "",
  created_by: "",
  published: "1",
  dashboard_box: "",
  download_access: 0,
  daily_resume_download_limit: 0,
  daily_excel_download_limit: 0,
  lgbt_confirmed: 0,
  nonlgbt: 0,
  nonlgbt_man: 0,
  nonlgbt_woman: 0,
};

const NewUser = (props) => {
  const { addCard, setAddCard, menuData, dataFetch } = props;
  const [addFormData, setAddFormData] = useState(initialState);
  const [errorMsg, setErrorMsg] = useState("");

  // Add contact function
  const handleAddFormChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    const newFormData = { ...addFormData };
    newFormData[fieldName] = fieldValue;
    setAddFormData(newFormData);
  };

  const validateEmail = useCallback((email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }, []);

  //Add Submit data
  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    var error = false;
    var errorMsg = "";
    if (addFormData.username === "") {
      error = true;
      errorMsg = "Please fill User Name";
    } else if (addFormData.email === "") {
      error = true;
      errorMsg = "Please fill User Email";
    } else if (!validateEmail(addFormData.email)) {
      error = true;
      errorMsg = "Please enter valid email";
    } else if (addFormData.password === "") {
      error = true;
      errorMsg = "Please fill Password";
    } else if (addFormData.repassword === "") {
      error = true;
      errorMsg = "Please fill Confirm Password";
    } else if (addFormData.password !== addFormData.repassword) {
      error = true;
      errorMsg = "Confirm password is not match with password";
    } else if (addFormData.role_id === "") {
      error = true;
      errorMsg = "Please select Role";
    } else if (addFormData.user_type === "2" && addFormData.quota === "") {
      error = true;
      errorMsg = "Please enter quota";
    } else if (addFormData.user_type === "") {
      error = true;
      errorMsg = "Please select user type";
    } else if (addFormData.daily_resume_download_limit === 0) {
      error = true;
      errorMsg = "Please enter daily resume download quota";
    } else if (addFormData.daily_excel_download_limit === 0) {
      error = true;
      errorMsg = "Please enter daily excel export quota";
    }

    if (!error) {
      const newContact = {
        name: addFormData.username,
        email: addFormData.email,
        password: addFormData.password,
        role_id: addFormData.role_id,
        quota: addFormData.quota,
        user_type: addFormData.user_type,
        created_by: 1,
        status: addFormData.published,
        dashboard_box: addFormData.dashboard_box,
        lgbt_confirmed: addFormData.lgbt_confirmed,
        nonlgbt: addFormData.nonlgbt,
        nonlgbt_man: addFormData.nonlgbt_man,
        nonlgbt_woman: addFormData.nonlgbt_woman,
        download_access: addFormData.download_access,
        resume_download_quota: addFormData.resume_download_quota,
        daily_resume_download_limit: addFormData.daily_resume_download_limit,
        daily_excel_download_limit: addFormData.daily_excel_download_limit,
      };
      await addNewUser(newContact);
      dataFetch(true);
      setAddCard(false);
      setAddFormData(initialState);
      swal("Successfully Added User!", "Successfully Added", "success");
    } else {
      setErrorMsg(errorMsg);
      //swal('Oops', errorMsg, "error");
    }
  };

  const handleCheckBoxes = useCallback(
    (e) => {
      const data = [
        ...document.querySelectorAll('input[name="dashboard_box"]:checked'),
      ].map((e) => e.value);
      setAddFormData((pre) => ({ ...pre, dashboard_box: data.join(",") }));
    },
    [setAddFormData]
  );

  const handleAccessType = useCallback(
    (e, className) => {
      const data = {};
      const inputs = document.getElementsByClassName(className);
      for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        if (input.type === "checkbox" || input.type === "radio") {
          if (input.checked) {
            data[input.name] = 1;
          } else {
            if (input.name == "nonlgbt") {
              data["nonlgbt_man"] = 0;
              data["nonlgbt_woman"] = 0;
            }
            data[input.name] = 0;
          }
        } else {
          data[input.name] = input.value;
        }
      }
      setAddFormData((pre) => ({ ...pre, ...data }));
    },
    [setAddFormData]
  );

  const handleDownloadAccessCheckBoxes = useCallback(
    (e) => {
      setAddFormData((pre) => ({
        ...pre,
        download_access: e.target.checked ? 1 : 0,
      }));
    },
    [setAddFormData]
  );

  return (
    <>
      <Modal
        className="modal fade bd-example-modal-lg"
        show={addCard}
        onHide={() => setAddCard(false)}
        centered
        size="lg"
      >
        <div role="document">
          <div className="">
            <form autoComplete="off">
              <div className="modal-header">
                <h4 className="modal-title fs-20">Add New User</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setAddCard(false)}
                  data-dismiss="modal"
                >
                  <span></span>
                </button>
              </div>
              <div className="modal-body">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <ErrorToast setErrorMsg={setErrorMsg} errorMsg={errorMsg} />

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-12">
                          <label className="text-black font-w500 mt-2">
                            Username <span className="text-danger">*</span>{" "}
                          </label>
                          <div className="contact-name">
                            <input
                              type="text"
                              className="form-control"
                              autoComplete="off"
                              name="username"
                              required="required"
                              onChange={handleAddFormChange}
                              placeholder="Enter User Name"
                            />
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-12">
                          <label className="text-black font-w500 mt-2">
                            User Email <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <input
                              type="text"
                              className="form-control"
                              autoComplete="off"
                              name="email"
                              required="required"
                              onChange={handleAddFormChange}
                              placeholder="Enter User Email Address"
                            />
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-12">
                          <label className="text-black font-w500 mt-2">
                            Password <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <input
                              type="password"
                              className="form-control"
                              autoComplete="off"
                              name="password"
                              required="required"
                              onChange={handleAddFormChange}
                              placeholder="Enter Password"
                            />
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-12">
                          <label className="text-black font-w500 mt-2">
                            Confirm Password{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <input
                              type="password"
                              className="form-control"
                              autoComplete="off"
                              name="repassword"
                              required="required"
                              onChange={handleAddFormChange}
                              placeholder="Enter Confirm Password"
                            />
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-12">
                          <label className="text-black font-w500 mt-2">
                            Select Role <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <select
                              className="form-select"
                              id="role_id"
                              name="role_id"
                              onChange={handleAddFormChange}
                            >
                              <option value="">Please select</option>
                              {menuData?.map((item, index) => {
                                return (
                                  <option value={item.id} key={index}>
                                    {item.role_name}
                                  </option>
                                );
                              })}
                            </select>

                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-12">
                          <label className="text-black font-w500 mt-2">
                            User Type <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <select
                              className="form-select"
                              id="user_type"
                              name="user_type"
                              onChange={handleAddFormChange}
                            >
                              <option value="">Select User Type</option>
                              <option value="1">Admin</option>
                              <option value="2">Editor</option>
                            </select>
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {addFormData.user_type === "2" && (
                      <>
                        <div className="form-group">
                          <label className="text-black font-w500 mt-2">
                            Access type
                          </label>
                          <div className="contact-name">
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input access_type"
                                type="checkbox"
                                name="lgbt_confirmed"
                                value="1"
                                id="lgbt_confirmed"
                                onChange={(e) =>
                                  handleAccessType(e, "access_type")
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="lgbt_confirmed"
                              >
                                LGBT Confirmed
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input access_type"
                                type="checkbox"
                                name="nonlgbt"
                                value="1"
                                id="nonlgbt"
                                onChange={(e) =>
                                  handleAccessType(e, "access_type")
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="nonlgbt"
                              >
                                Non LGBT+
                              </label>
                            </div>
                            {addFormData.nonlgbt == 1 && (
                              <>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input access_type"
                                    type="checkbox"
                                    name="nonlgbt_man"
                                    value="1"
                                    id="nonlgbt_man"
                                    onChange={(e) =>
                                      handleAccessType(e, "access_type")
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="nonlgbt_man"
                                  >
                                    Man
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input access_type"
                                    type="checkbox"
                                    name="nonlgbt_woman"
                                    value="1"
                                    id="nonlgbt_woman"
                                    onChange={(e) =>
                                      handleAccessType(e, "access_type")
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="nonlgbt_woman"
                                  >
                                    Woman
                                  </label>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="form-group mb-6">
                          <div className="row">
                            <div className="form-group mb-6 col-md-12">
                              <label className="text-black font-w500 mt-2">
                                Unlock Quota (per month)
                                <span className="text-danger">*</span>
                              </label>
                              <div className="contact-name">
                                <input
                                  type="number"
                                  className="form-control"
                                  autoComplete="off"
                                  name="quota"
                                  required="required"
                                  onChange={handleAddFormChange}
                                  placeholder="Unlock Quota"
                                />
                                <span className="validation-text"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="form-group">
                      <label className="text-black font-w500 mt-2">
                        Dashboard Summary Box
                      </label>
                      <div className="contact-name">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="AAP"
                            id="all_applicants"
                            //checked={true}
                            onChange={handleCheckBoxes}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="all_applicants"
                          >
                            All Applicants
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="RCT"
                            id="recruiters"
                            onChange={handleCheckBoxes}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="recruiters"
                          >
                            Recruiters
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="JOB"
                            id="jobs"
                            onChange={handleCheckBoxes}
                          />
                          <label className="form-check-label" htmlFor="jobs">
                            Jobs
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="EDT"
                            id="editor"
                            onChange={handleCheckBoxes}
                          />
                          <label className="form-check-label" htmlFor="editor">
                            Editor
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="SKL"
                            id="skills"
                            onChange={handleCheckBoxes}
                          />
                          <label className="form-check-label" htmlFor="skills">
                            Skills
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="LOC"
                            id="locations"
                            onChange={handleCheckBoxes}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="locations"
                          >
                            Locations
                          </label>
                        </div>
                        <span className="validation-text"></span>
                      </div>
                    </div>

                    <div className="form-group">
                      <label
                        className="text-black font-w500 mt-2"
                        htmlFor="download_access"
                      >
                        Download Access
                        <input
                          className="form-check-input ms-2"
                          type="checkbox"
                          name="download_access"
                          //value="1"
                          id="download_access"
                          //checked={true}
                          onChange={handleDownloadAccessCheckBoxes}
                        />
                      </label>
                    </div>

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-6">
                          <label className="text-black font-w500 mt-2">
                            Daily Resume download quota
                            <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <input
                              type="number"
                              className="form-control"
                              autoComplete="off"
                              name="daily_resume_download_limit"
                              required="required"
                              onChange={handleAddFormChange}
                              placeholder="Daily Resume download quota"
                            />
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-6">
                          <label className="text-black font-w500 mt-2">
                            Daily excel download quota
                            <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <input
                              type="number"
                              className="form-control"
                              autoComplete="off"
                              name="daily_excel_download_limit"
                              required="required"
                              onChange={handleAddFormChange}
                              placeholder="Daily excel download quota"
                            />
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="text-black font-w500 mt-2">
                        Status
                      </label>
                      <div className="contact-name">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="published"
                          value="1"
                          id="statusActive"
                          //checked={true}
                          //defaultChecked={true}
                          onChange={handleAddFormChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="statusActive"
                        >
                          Active
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="published"
                          value="0"
                          id="statusInactive"
                          onChange={handleAddFormChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="statusInactive"
                        >
                          InActive
                        </label>
                        <span className="validation-text"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-success"
                  onClick={handleAddFormSubmit}
                >
                  Add
                </button>
                <button
                  type="button"
                  onClick={() => setAddCard(false)}
                  className="btn btn-danger"
                >
                  <i className="flaticon-delete-1"></i> Discard
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default NewUser;
